'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (theme, props, state) {
    var palette = theme.palette;


    var searchIconOpacity = 0.38;

    if (state.focus) {
        searchIconOpacity = 0.87;
    }

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {},
        wrapper: {
            position: 'relative'
        },
        search: {
            position: 'absolute',
            width: theme.searchIconWidth,
            height: '100%',
            background: 'url("' + theme.searchIcon + '") no-repeat center',
            backgroundSize: theme.searchIconWidth + ' ' + theme.searchIconHeight,
            left: 0,
            top: 0,
            opacity: searchIconOpacity,
            transition: 'opacity ' + palette.transitionDuration + ' ' + palette.transitionFunction
        },
        clear: {
            position: 'absolute',
            width: theme.clearIconWidth,
            height: '100%',
            background: 'url("' + theme.clearIcon + '") no-repeat center',
            backgroundSize: theme.clearIconWidth + ' ' + theme.clearIconHeight,
            right: 0,
            top: 0,
            opacity: 0.38,
            transition: 'opacity ' + palette.transitionDuration + ' ' + palette.transitionFunction,

            '&:hover': {
                cursor: 'pointer',
                opacity: 0.87
            }
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        wrapper: (0, _aphroditeJss.css)(styleList.wrapper),
        search: (0, _aphroditeJss.css)(styleList.search),
        clear: (0, _aphroditeJss.css)(styleList.clear)
    };
};

var _aphroditeJss = require('aphrodite-jss');